import { render, staticRenderFns } from "./viewer.template?vue&type=template&id=13c43cb4&scoped=true&lang=pug&"
import script from "./viewer.client?vue&type=script&lang=ts&"
export * from "./viewer.client?vue&type=script&lang=ts&"
import style0 from "./viewer.style?vue&type=style&index=0&id=13c43cb4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c43cb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c43cb4')) {
      api.createRecord('13c43cb4', component.options)
    } else {
      api.reload('13c43cb4', component.options)
    }
    module.hot.accept("./viewer.template?vue&type=template&id=13c43cb4&scoped=true&lang=pug&", function () {
      api.rerender('13c43cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/attachments/viewer/viewer.component.vue"
export default component.exports